import { Component, Input } from '@angular/core';
import { ColorBgIconComponent } from '@forgerock/backstage-ui-components';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { EverythingSearchResult } from '../../../model/everything-search-result';
import { UniversityLearningPathUrlPipe } from '../../../pipe/university-learning-path-url.pipe';
import { SearchResultLinkDirective } from '../../../search-result-link.directive';
import { EllipsisComponent } from '../../../utils/ellipsis/ellipsis.component';
import { SearchResultCardComponent } from '../../search-result-card/search-result-card.component';

@Component({
  selector: 'app-search-result-chapter',
  templateUrl: './search-result-chapter.component.html',
  styleUrls: [ './search-result-chapter.component.scss' ],
  imports: [ SearchResultCardComponent, SearchResultLinkDirective, ColorBgIconComponent, NgbTooltip, EllipsisComponent, UniversityLearningPathUrlPipe ]
})
export class SearchResultChapterComponent {
  @Input() result: EverythingSearchResult;
}
